import React, { Component } from "react";
import { Layout, Button } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import KeycloakManager from "../../utils/keyCloakManager";
import { handleLogOut } from "../../utils/clearCache";
import { dataUser } from "../Helpers/util";
import Moment from 'react-moment';
import SwLogoLight from './../../assets/img/smartworks-logo-light.svg';
import SwOffCanvas from "../Common/SwOffCanvas/SwOffCanvas";
import SwButton from "../Common/SwButtons/SwButtons";

const { Header } = Layout;
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class CustomHeader extends Component {
  constructor(props) {
    super(props);
    const userData = localStorage.getItem("user_data");
    this.state = {
      user: userData ? JSON.parse(userData) : null, // User object
      currentVersion: "1.0.0", // Example version
      updatedOn: "2024-06-10", // Example update date
      showProfileDrawer: false, // Profile Drawer
    };
  }
  
  showProfileDrawer = () => {
    this.setState({ showProfileDrawer: true });
  };
  closeProfileDrawer = () => {
    this.setState({ showProfileDrawer: false });
  };

  logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("amsToken");
    localStorage.removeItem("user_data");
    sessionStorage.clear();
    mixpanel.track("LogOut Successful", { PageName: "LogOut", Type: "LogOut" });
    mixpanel.reset();
    window.location.href = "/";
  };



 

  render() {
    const { user, currentVersion, updatedOn } = this.state;
    const { collapsed, toggleCollapsed } = this.props; // Props from parent
    
    var dateNew = new Date();
    return (

      <>
      <Header>
        {/* Collapse Button */}
        {/* <Button
          type="text"
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          onClick={toggleCollapsed} // Call toggle function passed as prop
          style={{
            color: "black",
            fontSize: "18px",
          }}
        /> */}

        
        <nav className="header-navbar navbar-expand-md navbar fixed-top p-0">
          <div className="navbar-head">
              <div className="d-flex">
                <div className="menu-toggle-container d-md-block align-self-center ">
                  <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={toggleCollapsed} // Call toggle function passed as prop
                    style={{
                      color: "black",
                      fontSize: "18px",
                    }}
                  />
                </div>
                <div className="logo_container">
                  
                  <a className="csp_logo" href="#">
                    <img alt="" src={SwLogoLight}/>
                  </a> 
                  <span className="Separateor">/</span><span>Client Portal</span>
                </div>
            

                <div className="ms-auto top-head-nav d-flex align-items-center">
                
                  <div className="d-flex">
                  <a type="button" className="HeaderUserImg" onClick={this.showProfileDrawer}>
                    {UserObj ? (
                        <img src={UserObj.profile_img_url} alt="User" />
                      ) : 
                        <img src={ 'https://smartworks-production.s3-ap-southeast-1.amazonaws.com/app_profile/profile.png'} />
                      }
                    </a>
                    
                  </div>
                </div>
              </div>
            </div>
        </nav>


        {/* User Profile Icon */}
        
          {/* <Link
            to="#"
            data-toggle="modal"
            data-target="#myProfilePopup"
            className="userImgHeader"
          > 
            Popup
          </Link> */}


      </Header>

        {/* Profile Drawer */}
        <SwOffCanvas
          show={this.state.showProfileDrawer}
          onClose={this.closeProfileDrawer}
          title="My Profile"
          footer={
            <div className="OffCanvasFooter_Btns">
              <SwButton variant="dark-outline" onClick={this.closeProfileDrawer}>
                Cancel
              </SwButton>
              <SwButton variant="primary" onClick={handleLogOut}>
                Logout
              </SwButton>
            </div>
          }
        >
          <div className="loginDrawerContent">

            <div className="loginUserInfo">
              
              <div className="LoginUserImg">
                {UserObj ? (
                  <img src={UserObj.profile_img_url} alt="User" />
                ) : (
                  <img src={ 'https://smartworks-production.s3-ap-southeast-1.amazonaws.com/app_profile/profile.png'} />
                )}
              </div>

              
              <div className="LoginUserDetails">
                <div className="loginerName">
                  {UserObj ? UserObj.fname : null}{' '}
                  {UserObj ? UserObj.lname : null}
                </div>
                <div className="loginEmail">
                  {UserObj ? UserObj.email : null}
                </div>
              </div>
            </div>

            <div className="loginOtherInfo my-3">    
            
              <p class="SwTextDark"><span className="SwTextGray">Mobile Number: <strong>{'+'} {UserObj ? UserObj.phone : null}</strong></span></p>
            
              <p class="SwTextDark"><span className="SwTextGray">Company Name: <strong>{UserObj ? UserObj.company_name : '--'}</strong></span></p>
          
              <p class="SwTextDark"><span className="SwTextGray">Time Zone: <strong><Moment parse="YYYY-MM-DD HH:mm">{dateNew}</Moment></strong></span></p>
            
              <p class="SwTextDark"><span className="SwTextGray">Data Location: <strong>India</strong></span></p>
            
              <p class="SwTextDark"><span className="SwTextGray">Version: <strong>{this.state.currentVersion}</strong></span></p>
            
              <p class="SwTextDark"><span className="SwTextGray">Last Updated on: <strong>{this.state.updatedOn}</strong></span></p>
            
              <p class="SwTextDark"><span className="SwTextGray">The application is developed and maintained by <br /> <strong>Smartworks Tech Solutions Private Limited</strong></span></p>
            
              <a target="_blank" href="https://www.smartworksoffice.com/terms-conditions/" className="SwLinkInfo HoverUnderline fw-700 me-4">Info link</a>
              <a target="_blank" href="https://www.smartworksoffice.com/privacy-policy/" className="SwLinkInfo HoverUnderline fw-700">End User License</a>

            </div>

          </div>
          
          
          
        </SwOffCanvas>


        {/* Sidebar Menu Overlay */}
        <div className={`ant-sider-overlay ${collapsed ? '' : 'SiderExpanded'}`} onClick={toggleCollapsed} ></div>

    </>
    );
  }
}

export default CustomHeader;
